import { render, staticRenderFns } from "./UiFacebook.vue?vue&type=template&id=58516b5c"
import script from "./UiFacebook.vue?vue&type=script&lang=js"
export * from "./UiFacebook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports